import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.articleBrands.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.articleBrands.actionsLoading;
export const getItems = (state:RootState) => state.articleBrands.items;
export const getItemsSelect = (state:RootState) => state.articleBrands.dropDownItems;
export const getItemsCount = (state:RootState) => state.articleBrands.itemsCount;
export const getItemForEdit = (state:RootState) => state.articleBrands.itemForEdit;
export const getErrorAction = (state:RootState) => state.articleBrands.errorAction;
export const getError = (state:RootState) => state.articleBrands.error;
export const validationErrors = (state: RootState) => state.articleBrands.validationErrors;
